import React, { ReactNode } from "react";

export interface BadgeProps {
  variant?: "success" | "danger" | "warning" | "info" | "neutral";
  children: ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ variant = "neutral", children, className = "" }) => {
  return <span className={`badge badge-${variant} ${className}`.trim()}>{children}</span>;
};
